import React, { useState } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase"; // ajusta la ruta si lo mueves

import './Login.css'

const API_URL = process.env.REACT_APP_API_URL;

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      // 🔹 Login en Firebase
      const authInstance = getAuth();
      const userCredential = await signInWithEmailAndPassword(
        authInstance,
        email,
        password
      );
      const idToken = await userCredential.user.getIdToken(true);
      const { user } = userCredential;

      // 🔹 Llamada al backend para obtener tu JWT
      const res = await fetch(`${API_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (!res.ok) throw new Error("Error en login backend");
      const data = await res.json();
      
      if (data.is_Admin!==true){
        setError("No es un administrador, no le es posible ingresar");  
        return;
      }

      // 🔹 Guardar JWT en localStorage
      localStorage.setItem("access_token", data.access_token);
      localStorage.setItem("userEmail", email);
      localStorage.setItem("userId", user.uid);

      // 🔹 Redirigir al dashboard
      navigate("/gestion");
    } catch (err) {
      setError("Credenciales inválidas o error en login");
    } finally {
      setLoading(false);
    }
  };

  return (
     <div className="login-container">      
      <h2>Iniciar sesión</h2>
      <form onSubmit={handleLogin} noValidate>
        <div className="form-group">
          <label>Correo electrónico</label>
          <input
            type="email"
            placeholder="Correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="form-group password-group">
          <label>Contraseña</label>
          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
            <span
              className="toggle-visibility"
              onClick={() => setShowPassword((prev) => !prev)}
              title={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
            >
              {showPassword ? "🙈" : "👁️"}
            </span>
          </div>
        </div>

        <button type="submit" className="btn-login" disabled={loading}>
          {loading ? "Ingresando..." : "Ingresar"}
        </button>
      </form>

      {error && <p className="error-message">{error}</p>}
    </div>
  );
}